import { MissingDataState as ExoMissingDataState } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects Swedish default title/description.
export const MissingDataState = (
	props: ComponentProps<typeof ExoMissingDataState>,
) => {
	const { t } = useTranslation();
	return (
		<ExoMissingDataState
			title={t("No data found")}
			description={t("Something went wrong. Try reloading the page.")}
			{...props}
		/>
	);
};
